import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Standard} from '../../../../../models/standard.model';
import {Question} from '../../../../../models/question.model';
import {Answer} from '../../../../../models/answer.model';
import {MultiQuestions} from '../../../../../models/multi-questions';
import {AdminService} from '../../../../../services/admin.service';
import {Response} from '@angular/http';

@Component({
  selector: 'app-add-new-questions',
  templateUrl: './add-new-questions.component.html',
  styleUrls: ['./add-new-questions.component.css']
})
export class AddNewQuestionsComponent implements OnInit {
  standard: Standard;
  tmpStandard: any = null;
  successInfo = false;
  invalidQuestions = false;
  russianQuestion: Question;
  englishQuestion: Question;

  constructor(public activeModal: NgbActiveModal,
              private adminService: AdminService) {
  }

  ngOnInit() {
    this.russianQuestion = new Question(
      [new Answer(''),
        new Answer(''),
        new Answer('')],
       true,
      '',
      new Answer('')
    );

    this.englishQuestion = new Question(
      [new Answer(''),
        new Answer(''),
        new Answer('')],
        true,
      '',
      new Answer('')
    );
  }

	chekQuestionArr() {
		var n = this.tmpStandard.questions.russian.length;
		for (var i = 0; i < n; i++) { 
      if (this.russianQuestion.questionText === this.tmpStandard.questions.russian[i].questionText) return false; }
		return true;
	}

  setStandard(standard: Standard) {
    this.standard = standard;
  }

  setTempStandard(tmpStandard: any) {
    this.tmpStandard = tmpStandard;
  }

  addQuestion() {
    this.invalidQuestions = false;
    if (this.isQuestionsValid()) {
      this.successInfo = false;
      const newRuQuestion = this.setCorrectAnswer(this.russianQuestion);
      const newEnQuestion = this.setCorrectAnswer(this.russianQuestion);
      this.switchAddQuestion(newRuQuestion, newEnQuestion);      
    } else {
      this.invalidQuestions = true;
      this.successInfo = false;
    }
  }

  switchAddQuestion(newRuQuestion: Question, newEnQuestion: Question) {
    if (this.tmpStandard !== null) {
      this.tmpStandard.questions.russian.push(newRuQuestion);
      this.tmpStandard.questions.english.push(newRuQuestion);
      this.successInfo = true;
      this.ngOnInit();
    } else {
      const multiQuestion = new MultiQuestions([newRuQuestion], [newRuQuestion]);
      this.adminService.addQuestionToStandard(this.standard, multiQuestion).subscribe(
        (response) => {
          if (response.status === 200) {
            this.standard.russianQuestions.push(multiQuestion.russian[0]);
            this.standard.englishQuestions.push(multiQuestion.russian[0]);
            this.successInfo = true;
            this.ngOnInit();
          }
        }
      );
    }
  }

  private setCorrectAnswer(question: Question) {
    return new Question(
      question.answers,
      question.isTesting,
      question.questionText,
      question.answers[Number.parseInt(question.rightAnswer.answerText) - 1]
    );
  }

  isQuestionsValid() {
    if (this.russianQuestion.questionText === '' || (Number.parseInt(this.russianQuestion.rightAnswer.answerText) < 1
        || Number.parseInt(this.russianQuestion.rightAnswer.answerText) > 3)) {
      return false;
    }

    if (this.russianQuestion.answers[0].answerText === ''
      || this.russianQuestion.answers[1].answerText === ''
      || this.russianQuestion.answers[2].answerText === '') {
      return false;
    }

    const ruAnswersSet = new Set();
    ruAnswersSet.add(this.russianQuestion.answers[0].answerText);
    ruAnswersSet.add(this.russianQuestion.answers[1].answerText);
    ruAnswersSet.add(this.russianQuestion.answers[2].answerText);
    if (ruAnswersSet.size < this.russianQuestion.answers.length) {
      return false;
    }
    const enAnswersSet = new Set();
    enAnswersSet.add(this.russianQuestion.answers[0].answerText);
    enAnswersSet.add(this.russianQuestion.answers[1].answerText);
    enAnswersSet.add(this.russianQuestion.answers[2].answerText);
    if (enAnswersSet.size < this.russianQuestion.answers.length) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-standard/popups/add-new-questions/add-new-questions.component.ts